module.exports = __webpack_public_path__ + "img/19a.0a9946df.png";